import INVENTORY_API_BASE_URL from "../../config/api";
import "./ReturnInbound.css";
import Axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import swal from "sweetalert";
import alertify from "alertifyjs";

function ReturnInbound() {
  const [data, setData] = useState([]);
  const [shelf, setshelf] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const barcodeInputRef = useRef(null);
  const [showSelectedTable, setShowSelectedTable] = useState(false);
  const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
  const [rowCheckboxSelected, setRowCheckboxSelected] = useState({});
  const [checkboxClickCount, setCheckboxClickCount] = useState(0);
  const [barcodeCount, setBarcodeCount] = useState(0);
  const [rowSums, setRowSums] = useState([]);
  const [sku, setsku] = useState([]);
  const [orderseq, setorderseq] = useState([]);
  const [title, setTitle] = useState([]);
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(40); 
  const [totalPages, setTotalPages] = useState(0);
  const [selectedShelfId, setSelectedShelfId] = useState(null); 
  const [searchTerm, setSearchTerm] = useState("");

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManagereturn`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setData(response.data);
      }
    );
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        const reversedData = response.data.reverse();
        setshelf(response.data);
      }
    );
  }, []);

  const handleCheckboxChange = (event, SKU, OrderSeq, Title) => {
    const isChecked = event.target.checked;
    setsku(SKU);
    setorderseq(OrderSeq);
    setTitle(Title);
    setRowCheckboxSelected((prevSelected) => ({
      ...prevSelected,
      [SKU]: isChecked,
    }));
    if (isChecked) {
      const matchingShelfEntries = shelf.filter((entry) => entry.sku === SKU);
      if (matchingShelfEntries.length > 0) {
        setSelectedRows((prevSelectedRows) => [
          ...prevSelectedRows,
          ...matchingShelfEntries,
        ]);
        setShowSelectedTable(true);
      }
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((entry) => entry.sku !== SKU)
      );
      if (selectedRows.length === 1) {
        setShowSelectedTable(false);
      }
    }

    setCheckboxClickCount((prevCount) => prevCount + 1);
    if (checkboxClickCount === 1) {
      window.location.reload();
    }
  };

  const handleBarcodeScanned = (scannedBarcode) => {
    console.log("Scanned Barcode:", scannedBarcode);

    if (!isCheckboxClicked) {
      swal({
        title: "Please select checkbox",
        icon: "error",
      });
      setBarcode("");
      return;
    }
    const uppercaseBarcode = scannedBarcode.toUpperCase();

    if (!uppercaseBarcode.includes(sku)) {
      alertify.error(`SKU ${sku} not found in the barcode.`);
      setBarcode("");
      barcodeInputRef.current.focus();
      return;
    }

    if (enteredBarcodesList.includes(uppercaseBarcode)) {
      alertify.error("Barcode is already scanned here.");
      setBarcode("");
      barcodeInputRef.current.focus();
      return;
    }

    const isBarcodeInShelf = shelf.some((shelfItem) =>
      shelfItem.barcodeData.includes(uppercaseBarcode)
    );

    if (isBarcodeInShelf) {
      alertify.error("Barcode is already present in shelf.");
      setBarcode("");
      barcodeInputRef.current.focus();
      return;
    }

    const updatedBarcodeList = [...enteredBarcodesList, uppercaseBarcode];
    setEnteredBarcodesList(updatedBarcodeList);
    setBarcode("");
    setBarcodeCount(barcodeCount + 1);
    alertify.success(`Barcode ${uppercaseBarcode} added successfully.`);
    barcodeInputRef.current.focus();
  };

  useEffect(() => {
    const calculatedSums = selectedRows.map(
      (row) => row.presentquantity + barcodeCount
    );
    setRowSums(calculatedSums);
    const handleClickOutside = (event) => {
      if (
        barcodeInputRef.current &&
        !barcodeInputRef.current.contains(event.target)
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, [selectedRows, barcodeCount]);

  const handleShelfCheckboxChange = (event, shelfId) => {
    const isChecked = event.target.checked;
    setSelectedShelfId(shelfId); 
    setIsCheckboxClicked(true);
    barcodeInputRef.current.focus();
  };

  const handleSubmit = async () => {
    if (selectedRows.length === 0) {
      return;
    }

    const selectedRow = selectedRows.find((row) => row._id === selectedShelfId); 
    const sum = selectedRow.presentquantity + barcodeCount;
    const newemptyspace = selectedRow.emptyspace - barcodeCount;

    try {
      const putawayResponse = await Axios.put(
        `${INVENTORY_API_BASE_URL}/putaway`,
        {
          id: selectedRow._id,
          barcodeData: enteredBarcodesList,
          presentquantity: sum,
          emptyspace: newemptyspace,
        }
      );
      console.log("Putaway data sent successfully:", putawayResponse.data);

      const scanReturnResponse = await Axios.post(
        `${INVENTORY_API_BASE_URL}/scanReturnInbound`,
        {
          grnNo: orderseq,
          barcodeData: enteredBarcodesList,
          count: barcodeCount,
          sku: sku,
          Title: title,
        }
      );
      console.log(
        "Scan return inbound data sent successfully:",
        scanReturnResponse.data
      );

      swal({
        title: "Inbound completed",
        icon: "success",
      });

      window.location.reload();
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  console.log(selectedRows);

  useEffect(() => {
    if (data.length > 0) {
      const pages = Math.ceil(data.length / itemsPerPage);
      setTotalPages(pages);
    }
  }, [data, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginate = (array, page_number, page_size) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const getPageRange = () => {
    const maxPagesToShow = 15;
    const middlePage = Math.ceil(maxPagesToShow / 2);
    let startPage = Math.max(currentPage - middlePage, 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    endPage = Math.min(endPage, totalPages);

    startPage = Math.max(endPage - maxPagesToShow + 1, 1);

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const filteredData = data
  .flatMap((row) =>
    row.Entries.map((entry) => ({
      ...entry,
      OrderSeq: row.OrderSeq?.toString() || "",
      Distributor: row.Distributor || "",
      Invoice_Number: row.Invoice_Number || "",
      Date: row.Date || "",
    }))
  )
  .filter(
    (entry) =>
      entry.OrderSeq.toLowerCase().includes(searchTerm.toLowerCase()) ||
      entry.SKU.toLowerCase().includes(searchTerm.toLowerCase())
  );

useEffect(() => {
  const pages = Math.ceil(filteredData.length / itemsPerPage);
  setTotalPages(pages);
}, [filteredData, itemsPerPage]);
  

  return (
    <main className="return-inbound-page">
      <div className="return-inbound-shell">
        <header className="return-inbound-hero">
          <div>
            <p className="return-inbound-eyebrow"><span aria-hidden="true" /> RETURNS / INBOUND SCANNING</p>
            <h1>Return Inbound</h1>
            <p>Find a return line, assign a shelf, and scan its barcodes into stock.</p>
          </div>
          <div className="return-inbound-live-card">
            <span className="return-inbound-live-dot" aria-hidden="true" />
            <div><strong>Inbound scan desk</strong><small>Ready to receive returned stock</small></div>
          </div>
        </header>

        <section className="return-inbound-metrics" aria-label="Inbound summary">
          <article className="return-inbound-metric">
            <span className="return-inbound-metric-icon return-inbound-metric-icon--blue" aria-hidden="true">GRN</span>
            <div><span>Return lines</span><strong>{filteredData.length.toLocaleString()}</strong><small>Matching your search</small></div>
          </article>
          <article className="return-inbound-metric">
            <span className="return-inbound-metric-icon return-inbound-metric-icon--green" aria-hidden="true">SCAN</span>
            <div><span>Barcodes scanned</span><strong>{barcodeCount.toLocaleString()}</strong><small>In this inbound session</small></div>
          </article>
          <article className="return-inbound-metric">
            <span className="return-inbound-metric-icon return-inbound-metric-icon--violet" aria-hidden="true">PAGE</span>
            <div><span>Current page</span><strong>{totalPages === 0 ? 0 : currentPage} <em>/ {totalPages}</em></strong><small>{itemsPerPage} lines per page</small></div>
          </article>
        </section>

        <section className="return-inbound-card" aria-labelledby="return-inbound-lines-title">
          <div className="return-inbound-toolbar">
            <div>
              <h2 id="return-inbound-lines-title">Return lines</h2>
              <p>Select the SKU row you are receiving, then choose the destination shelf.</p>
            </div>
            <label className="return-inbound-search">
              <span aria-hidden="true">⌕</span>
              <input
                type="text"
                placeholder="Search GRN number or SKU"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-label="Search by GRN number or SKU"
              />
            </label>
          </div>

          <div className="return-inbound-pagination-row">
            <div className="return-inbound-result-count">
              <span className="return-inbound-status-dot" aria-hidden="true" />
              {filteredData.length === 0 ? (
                <span>No return lines found</span>
              ) : (
                <span>Showing <strong>{(currentPage - 1) * itemsPerPage + 1}–{Math.min(currentPage * itemsPerPage, filteredData.length)}</strong> of <strong>{filteredData.length.toLocaleString()}</strong> lines</span>
              )}
            </div>
            <nav className="return-inbound-pagination" aria-label="Return line pages">
              <button
                type="button"
                className="return-inbound-page-button"
                onClick={handlePreviousPage}
                disabled={currentPage === 1 || totalPages === 0}
              ><span aria-hidden="true">←</span> Previous</button>
              <div className="return-inbound-page-numbers">
                {getPageRange().map((pageNumber) => (
                  <button
                    type="button"
                    className={pageNumber === currentPage ? "return-inbound-page-number return-inbound-page-number--active" : "return-inbound-page-number"}
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                    disabled={pageNumber === currentPage}
                    aria-current={pageNumber === currentPage ? "page" : undefined}
                  >{pageNumber}</button>
                ))}
              </div>
              <button
                type="button"
                className="return-inbound-page-button"
                onClick={handleNextPage}
                disabled={currentPage === totalPages || totalPages === 0}
              >Next <span aria-hidden="true">→</span></button>
            </nav>
          </div>

          {filteredData.length > 0 ? (
            <div className="return-inbound-table-wrap">
              <Table className="return-inbound-table">
                <thead>
                  <tr>
                    <th scope="col">Select</th>
                    <th scope="col">GRN No.</th>
                    <th scope="col">Distributor</th>
                    <th scope="col">SKU</th>
                    <th scope="col">Title</th>
                    <th scope="col">Edition</th>
                    <th scope="col">Medium</th>
                    <th scope="col">Return qty</th>
                    <th scope="col">Good qty</th>
                    <th scope="col">Bad qty</th>
                    <th scope="col">Invoice no.</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginate(filteredData, currentPage, itemsPerPage).map((entry, index) => (
                    <tr key={entry.OrderSeq + "-" + entry.SKU + "-" + index}>
                      <td>
                        <input
                          className="return-inbound-checkbox"
                          type="checkbox"
                          onChange={(event) => handleCheckboxChange(event, entry.SKU, entry.OrderSeq, entry.Title)}
                          aria-label={"Select " + entry.SKU + " from GRN " + entry.OrderSeq}
                        />
                      </td>
                      <td><span className="return-inbound-grn">{entry.OrderSeq}</span></td>
                      <td className="return-inbound-distributor">{entry.Distributor}</td>
                      <td><span className="return-inbound-sku">{entry.SKU}</span></td>
                      <td className="return-inbound-title" title={entry.Title}>{entry.Title}</td>
                      <td>{entry.Edition}</td>
                      <td>{entry.Medium}</td>
                      <td>{entry.Return_Quantity}</td>
                      <td><span className="return-inbound-good-qty">{entry.Good_Quantity}</span></td>
                      <td>{entry.Bad_Quantity}</td>
                      <td>{entry.Invoice_Number}</td>
                      <td>{formatDate(entry.Date)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="return-inbound-empty">
              <span aria-hidden="true">⌕</span>
              <strong>No return lines match</strong>
              <p>Try another GRN number or SKU search.</p>
            </div>
          )}
        </section>

        {showSelectedTable && (
          <section className="return-inbound-card return-inbound-shelf-card" aria-labelledby="return-inbound-shelf-title">
            <div className="return-inbound-toolbar">
              <div>
                <p className="return-inbound-section-kicker">NEXT STEP / STORAGE</p>
                <h2 id="return-inbound-shelf-title">Choose a destination shelf</h2>
                <p>Select the shelf that will receive the scanned books.</p>
              </div>
              <div className="return-inbound-selection-pill">
                {selectedRows.length.toLocaleString()} matching shelf{selectedRows.length === 1 ? "" : "s"}
              </div>
            </div>
            <div className="return-inbound-table-wrap return-inbound-shelf-wrap">
              <Table className="return-inbound-table return-inbound-shelf-table">
                <thead>
                  <tr>
                    {["Select shelf", "Warehouse", "Rack", "Shelf", "SKU", "Type", "Capacity", "Empty space", "Present qty", "Added qty", "Total qty"].map((header) => (
                      <th key={header} scope="col">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {selectedRows.map((row, index) => {
                    const sum = row.presentquantity + barcodeCount;
                    const newemptyspace = row.emptyspace - barcodeCount;
                    return (
                      <tr key={row._id || index}>
                        <td><input
                          className="return-inbound-checkbox"
                          type="checkbox"
                          onChange={(event) => handleShelfCheckboxChange(event, row._id)}
                          aria-label={"Select shelf " + row.shelfno + " in " + row.Warehouse}
                        /></td>
                        <td>{row.Warehouse}</td>
                        <td>{row.rackno}</td>
                        <td><span className="return-inbound-sku">{row.shelfno}</span></td>
                        <td>{row.sku}</td>
                        <td>{row.type}</td>
                        <td>{row.capacity}</td>
                        <td>{newemptyspace}</td>
                        <td>{row.presentquantity}</td>
                        <td><span className="return-inbound-added">{barcodeCount}</span></td>
                        <td><strong>{sum}</strong></td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <div className="return-inbound-scan-grid">
              <div className="return-inbound-scan-panel">
                <div className="return-inbound-scan-heading">
                  <span className="return-inbound-scan-icon" aria-hidden="true">⌁</span>
                  <div><h3>Scan returned barcodes</h3><p>Keep the scanner focused here; press Enter after each barcode.</p></div>
                </div>
                <label className="return-inbound-field-label" htmlFor="return-inbound-barcode">Barcode</label>
                <div className="return-inbound-scan-control">
                  <input
                    id="return-inbound-barcode"
                    className="return-inbound-barcode-input"
                    type="text"
                    ref={barcodeInputRef}
                    value={barcode}
                    onChange={(e) => setBarcode(e.target.value)}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        handleBarcodeScanned(barcode);
                      }
                    }}
                    placeholder="Scan or type barcode"
                  />
                  <button
                    className="return-inbound-primary-button"
                    type="button"
                    onClick={() => handleBarcodeScanned(barcode)}
                  >Add barcode <span aria-hidden="true">→</span></button>
                </div>
                <p className="return-inbound-helper">Selected SKU: <strong>{sku || "Choose an item above"}</strong></p>
              </div>
              <div className="return-inbound-scanned-panel">
                <div className="return-inbound-scan-heading">
                  <span className="return-inbound-scan-icon return-inbound-scan-icon--green" aria-hidden="true">✓</span>
                  <div><h3>Scanned in this session</h3><p>{enteredBarcodesList.length.toLocaleString()} barcode{enteredBarcodesList.length === 1 ? "" : "s"} added</p></div>
                </div>
                {enteredBarcodesList.length > 0 ? (
                  <ul className="return-inbound-barcode-list">
                    {enteredBarcodesList.map((scanned, index) => (
                      <li key={scanned + index}><span aria-hidden="true">✓</span>{scanned}</li>
                    ))}
                  </ul>
                ) : (
                  <div className="return-inbound-barcode-empty">Scanned barcodes will appear here.</div>
                )}
              </div>
            </div>
          </section>
        )}

        <footer className="return-inbound-submit-bar">
          <div><strong>Complete inbound</strong><span>Save the scanned barcodes to the selected shelf.</span></div>
          <button type="button" className="return-inbound-save-button" onClick={handleSubmit}>
            Save scanned ID <span aria-hidden="true">→</span>
          </button>
        </footer>
      </div>
    </main>
  );

}

export default ReturnInbound;
